var _rect, _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "url(#paint0_linear_1624_48481)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 13.625C11.4328 13.625 11.125 13.9328 11.125 14.3125C11.125 14.6922 11.4328 15 11.8125 15H18.6875C19.0672 15 19.375 14.6922 19.375 14.3125C19.375 13.9328 19.0672 13.625 18.6875 13.625H11.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.125 17.0625C11.125 16.6828 11.4328 16.375 11.8125 16.375H18.6875C19.0672 16.375 19.375 16.6828 19.375 17.0625C19.375 17.4422 19.0672 17.75 18.6875 17.75H11.8125C11.4328 17.75 11.125 17.4422 11.125 17.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.125 19.8125C11.125 19.4328 11.4328 19.125 11.8125 19.125H14.5625C14.9422 19.125 15.25 19.4328 15.25 19.8125C15.25 20.1922 14.9422 20.5 14.5625 20.5H11.8125C11.4328 20.5 11.125 20.1922 11.125 19.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3125 4H9.75C8.23122 4 7 5.23122 7 6.75V23.25C7 24.7688 8.23122 26 9.75 26H20.75C22.2688 26 23.5 24.7688 23.5 23.25V10.1875L17.3125 4ZM17.3125 5.375V8.125C17.3125 9.26409 18.2359 10.1875 19.375 10.1875H22.125V23.25C22.125 24.0094 21.5094 24.625 20.75 24.625H9.75C8.99061 24.625 8.375 24.0094 8.375 23.25V6.75C8.375 5.99061 8.99061 5.375 9.75 5.375H17.3125Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 14.625C12.4328 14.625 12.125 14.9328 12.125 15.3125C12.125 15.6922 12.4328 16 12.8125 16H19.6875C20.0672 16 20.375 15.6922 20.375 15.3125C20.375 14.9328 20.0672 14.625 19.6875 14.625H12.8125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 18.0625C12.125 17.6828 12.4328 17.375 12.8125 17.375H19.6875C20.0672 17.375 20.375 17.6828 20.375 18.0625C20.375 18.4422 20.0672 18.75 19.6875 18.75H12.8125C12.4328 18.75 12.125 18.4422 12.125 18.0625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 20.8125C12.125 20.4328 12.4328 20.125 12.8125 20.125H15.5625C15.9422 20.125 16.25 20.4328 16.25 20.8125C16.25 21.1922 15.9422 21.5 15.5625 21.5H12.8125C12.4328 21.5 12.125 21.1922 12.125 20.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3125 5H10.75C9.23122 5 8 6.23122 8 7.75V24.25C8 25.7688 9.23122 27 10.75 27H21.75C23.2688 27 24.5 25.7688 24.5 24.25V11.1875L18.3125 5ZM18.3125 6.375V9.125C18.3125 10.2641 19.2359 11.1875 20.375 11.1875H23.125V24.25C23.125 25.0094 22.5094 25.625 21.75 25.625H10.75C9.99061 25.625 9.375 25.0094 9.375 24.25V7.75C9.375 6.99061 9.99061 6.375 10.75 6.375H18.3125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1624_48481",
    x1: 0,
    y1: 0,
    x2: 32.0449,
    y2: 0.0450633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7C69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.c19177327673c8cd2c3093e372dfc965.svg";
export { ForwardRef as ReactComponent };